import DOM from '@/scripts/old/modules/jqueryDOM';

function ProductVars() {
  DOM.$document.on('click', '.js-product-vars__row', function toggleRadio(e) {
    e.preventDefault();
    const $checkbox = $(this).find('input[type=checkbox]');

    if ($checkbox.attr('disabled')) return;

    if (!$checkbox.prop('checked')) {
      $checkbox.prop('checked', true);
    } else {
      $checkbox.prop('checked', false);
    }
  });
}

export default new ProductVars();
